import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Message } from "primereact/message";
import { useState } from "react";
import { CatRunChangeResult } from "../../../client/types.gen";
import { reasonDetailLabel, staleRunChangeSummary } from "./staleResults";
import styles from "./CatRunStatusIndicator.module.css";

// Detailed staleness banner for the selected vendor — the summary plus its
// specific triggers in a collapsible section. The at-a-glance per-vendor
// version lives on the model tabs (CatModelSwitcher); this explains the "why".
export const CatRunStatusIndicator: React.FC<{
  result: CatRunChangeResult;
}> = ({ result }) => {
  const [showReasons, setShowReasons] = useState(false);

  // Non-null for exactly the stale change values, so this also gates the banner.
  const summary = staleRunChangeSummary(result.change);
  if (!summary) return null;

  return (
    <Message
      severity="warn"
      className={styles.banner}
      content={
        <div className={styles.content}>
          <div className={styles.header}>
            <span>{summary}</span>
            <Button
              text
              size="small"
              label={showReasons ? "Hide details" : "Show details"}
              icon={showReasons ? "pi pi-chevron-up" : "pi pi-chevron-down"}
              onClick={() => setShowReasons((shown) => !shown)}
            />
          </div>
          {showReasons && (
            <div className={styles.reasonChips}>
              {result.reasons.map((detail) => (
                <Chip key={detail.reason} label={reasonDetailLabel(detail)} />
              ))}
            </div>
          )}
        </div>
      }
    />
  );
};
